import React from "react";

/**
 * VehicleDetailMileageIcon
 *
 * Icon for vehicle mileage detail. Used in VehicleDetailsList.
 */
const VehicleDetailMileageIcon: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10 1V3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    ></path>
    <path
      d="M10 8V10.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    ></path>
    <path
      d="M10 15V18"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    ></path>
    <path
      d="M1 19L4 1"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    ></path>
    <path
      d="M16 1L19 19"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    ></path>
  </svg>
);

export default VehicleDetailMileageIcon;
